import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { IconButton, Tooltip, TextField } from '@material-ui/core';
import { Fullscreen, ArrowBack } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import api from 'axios';
import { isNull, isArray } from 'lodash';

import { Islands } from '~/componentsLocal';
import { t } from '~/helpers';

import * as S from './styles';

export default function SinoticoDescarregamentoFull() {
  const handle = useFullScreenHandle();
  const modalRef = useRef(null);

  const [data, setData] = useState([]);
  const [postos, setPostos] = React.useState([]);
  const [posto, setPosto] = React.useState(null);
  const [idposto, setIdPosto] = React.useState(null);

  const token = useSelector((state) => state.auth);

  const handleRequestAPI = useCallback(
    async (idposto) => {
      try {
        const request = idposto
          ? await api.get(
              `${process.env.REACT_APP_URL_REQUEST}descargasnfs/sinotico/posto/${idposto}`,
              {
                headers: {
                  'Current-Route': window.location.pathname,
                  Authorization: 'Bearer ' + `${token.token}`,
                },
              }
            )
          : await api.get(
              `${process.env.REACT_APP_URL_REQUEST}descargasnfs/sinotico`,
              {
                headers: {
                  'Current-Route': window.location.pathname,
                  Authorization: 'Bearer ' + `${token.token}`,
                },
              }
            );
        setData(request.data);
      } catch (error) {
        if (isArray(error)) error.map((err) => toast.error(t(err)));
        else toast.error(t(error));
      }
    },
    [idposto]
  );

  React.useEffect(() => {
    handleGetPostosComboios();
  }, []);

  const handleGetPostosComboios = React.useCallback(async () => {
    const params = { pagesize: 9999, statusposto: 'L', pesquisalista: true };
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_URL_REQUEST}postoscomboios`,
        {
          params,
          headers: {
            'Current-Route': window.location.pathname,
            Authorization: 'Bearer ' + `${token.token}`,
          },
        }
      );
      setPostos(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      //
    }
  }, []);

  const handleChangeAutocomplete = React.useCallback(
    (value) => {
      if (isNull(value)) {
        handleResetVars();
      } else {
        const { idposto } = value;
        setPosto(value);
        setIdPosto(idposto);
        // carrega os dados
        handleRequestAPI(idposto);
      }
    },
    [idposto]
  );

  const handleResetVars = React.useCallback(() => {
    setPosto(null);
    setIdPosto(null);
  }, []);

  useEffect(() => {
    handleRequestAPI(idposto);
  }, [idposto]);

  useEffect(() => {
    const timeOut = setInterval(() => {
      handleRequestAPI(idposto);
    }, 15000);

    return () => clearInterval(timeOut);
  }, [idposto]);

  return (
    <S.WrapperFullScreen>
      {!handle.active && (
        <header>
          <Tooltip title="FullScreen">
            <IconButton color="primary" size="small" onClick={handle.enter}>
              <Fullscreen />
            </IconButton>
          </Tooltip>
        </header>
      )}

      <FullScreen handle={handle}>
        {handle.active && (
          <Tooltip title="Voltar">
            <IconButton
              style={{
                position: 'absolute',
                top: '10px',
                left: '20px',
                backgroundColor: 'White',
              }}
              color="primary"
              size="small"
              onClick={handle.exit}
            >
              <ArrowBack color="secondary" />
            </IconButton>
          </Tooltip>
        )}

        <S.Wrapper fullScreen={handle.active}>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Autocomplete
              options={postos}
              value={posto}
              getOptionLabel={(posto) => `${posto.codigonomeposto}`}
              size="small"
              style={{ width: '100%', minWidth: '200px' }}
              fullWidth
              onChange={(e, value) => handleChangeAutocomplete(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('s.operacao.abastecimento.nomeposto')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{ marginTop: 10 }}
                />
              )}
            />
            {data?.map((item) => (
              <Islands
                key={Math.random().toString()}
                data={item}
                idposto={item.idposto}
                modalRef={modalRef}
              />
            ))}
          </div>
        </S.Wrapper>
      </FullScreen>
    </S.WrapperFullScreen>
  );
}
